// src/pages/about/changelog/add-changelog/saveChangelogHandler.js
import { saveToGoogleSheets, fetchChangelogFromGoogleSheets } from "../googleSheetsService";

/**
 * Fungsi untuk menangani penyimpanan changelog
 * @param {Object} params - Parameter fungsi
 * @param {Object} params.formData - Data form yang akan disimpan
 * @param {Object} params.user - User yang sedang login
 * @param {string} params.dialogMode - Mode dialog ('add' atau 'edit')
 * @param {Object} params.selectedChangelog - Data changelog yang dipilih (untuk edit)
 * @param {Function} params.setSnackbar - Fungsi untuk mengatur snackbar
 * @param {Function} params.setDialogOpen - Fungsi untuk mengatur buka/tutup dialog
 * @param {Function} params.setSelectedChangelog - Fungsi untuk mengatur changelog yang dipilih
 * @param {Function} params.setFormData - Fungsi untuk mengatur data form
 * @param {Function} params.setOriginalDataList - Fungsi untuk mengatur data asli
 * @param {Function} params.setDataList - Fungsi untuk mengatur data list
 * @param {Function} params.setPage - Fungsi untuk mengatur halaman
 * @param {Function} params.setIsSaving - Fungsi untuk mengatur status saving
 * @returns {Promise<void>}
 */
export const handleSaveChangelog = async ({
    formData,
    user,
    dialogMode,
    selectedChangelog,
    setSnackbar,
    setDialogOpen,
    setSelectedChangelog,
    setFormData,
    setOriginalDataList,
    setDataList,
    setPage,
    setIsSaving
}) => {
    // Validasi form
    if (!formData.title.trim()) {
        setSnackbar({
            open: true,
            message: "Judul harus diisi",
            severity: "warning",
        });
        return;
    }

    if (!formData.category) {
        setSnackbar({
            open: true,
            message: "Kategori harus dipilih",
            severity: "warning",
        });
        return;
    }

    if (!formData.datetime) {
        setSnackbar({
            open: true,
            message: "Tanggal dan waktu harus dipilih",
            severity: "warning",
        });
        return;
    }

    if (!formData.status) {
        setSnackbar({
            open: true,
            message: "Status harus dipilih",
            severity: "warning",
        });
        return;
    }

    try {
        setIsSaving(true);
        
        console.log('Starting save process...');
        
        // Simpan ke Google Sheets
        let result;
        if (dialogMode === 'add') {
            result = await saveToGoogleSheets(formData, user, 'ADD_CHANGELOG');
        } else {
            result = await saveToGoogleSheets(formData, user, 'UPDATE_CHANGELOG', selectedChangelog.id);
        }
        
        if (result.success) {
            setSnackbar({
                open: true,
                message: dialogMode === 'add' 
                    ? `Changelog berhasil ditambahkan! ID: ${result.id}`
                    : `Changelog berhasil diperbarui! ID: ${result.id}`,
                severity: "success",
            });
            
            // Tutup dialog
            setDialogOpen(false);
            setSelectedChangelog(null);
            
            // Reset form data
            setFormData({
                title: '',
                description: '',
                category: '',
                datetime: '',
                status: ''
            });
            
            // Refresh data setelah 1 detik
            setTimeout(async () => {
                try {
                    console.log('Refreshing data after save...');
                    const loadedData = await fetchChangelogFromGoogleSheets();
                    
                    if (loadedData.length > 0) {
                        loadedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                        setOriginalDataList(loadedData);
                        setDataList(loadedData);
                        setPage(0); // Reset ke halaman pertama
                    }
                } catch (refreshError) {
                    console.error("Error refreshing data:", refreshError);
                }
            }, 1500);
            
        } else {
            throw new Error(result.message || 'Gagal menyimpan ke Google Sheets');
        }
    } catch (error) {
        console.error("Error saving changelog:", error);
        setSnackbar({
            open: true,
            message: `Gagal menyimpan changelog: ${error.message}`,
            severity: "error",
        });
    } finally {
        setIsSaving(false);
    }
};